import React from "react";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { MAIN_THEME_COLOR } from "../../../providers/theme/colors/colors";

type DycWarningModalProps = {
  open: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel?: () => void;
  showCancel?: boolean;
};

export default function DycWarningModal({
  open,
  title,
  message,
  confirmText = "Proceed",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  showCancel = true,
}: DycWarningModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onCancel || onConfirm}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 1,
        },
      }}
    >
      <DialogTitle textAlign="center" sx={{ pt: 3, pb: 1 }}>
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            backgroundColor: "#fff4e5",
            color: "#ed6c02",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 1.5,
          }}
        >
          <WarningAmberRoundedIcon sx={{ fontSize: 36 }} />
        </Box>
        <Typography variant="h6" fontWeight={800} color={MAIN_THEME_COLOR}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ textAlign: "center", py: 1 }}>
        <Typography variant="body1" color="text.secondary">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 2.5, px: 3, gap: 1.5 }}>
        {showCancel && onCancel ? (
          <Button
            onClick={onCancel}
            variant="outlined"
            sx={{
              borderRadius: 999,
              px: 3,
              py: 0.8,
              borderColor: "divider",
              color: "text.primary",
            }}
          >
            {cancelText}
          </Button>
        ) : null}
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            borderRadius: 999,
            px: 3,
            py: 0.8,
            backgroundColor: MAIN_THEME_COLOR,
            "&:hover": {
              backgroundColor: MAIN_THEME_COLOR,
            },
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
